import { render } from "./Edit.vue?vue&type=template&id=2d3ca16c&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2d3ca16c"

export default script